"use strict";
exports.__esModule = true;
var length_1 = require("./length");
var name_1 = require("./name");
var length_2 = require("../config/length");
var validateSmartHomeName = function (value, isAdmin) {
    var maxLength = length_2["default"].smartHomeName;
    if (value.length > maxLength) {
        return length_1["default"](value, maxLength, 'Название диалога');
    }
    return name_1["default"](value, isAdmin, 'Название диалога');
};
exports["default"] = validateSmartHomeName;
